import { Button, Card, Col, Row, Typography } from "antd";
import {
  AdminMenuLayout,
  ModalWarehouseProducts,
  ModalWarehouseSauces,
} from "../../../../shared/components";
import { TableProductWarehouses } from "./TableProductWarehouses";
import { WrapperTabNav } from "../../../products";
import { PlusOutlined } from "@ant-design/icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TableSauceWarehouses } from "../../../sauces/ui/sauceById/TableSauceWarehouses";

const { Title, Text } = Typography;

export const WarehouseById = () => {
  const navigate = useNavigate();
  const [openModalAsignedProduct, setOpenModalAsignedProduct] =
    React.useState<boolean>(false);
    const [openModalAsignedSouce, setOpenModalAsignedSouce] = React.useState<boolean>(false)

  return (
    <AdminMenuLayout pageDescription="Warehouses" title="Warehouses">
      <Card>
      <Text
          style={{ color: "gray", cursor: "pointer" }}
          onClick={() => navigate("/warehouses")}
        >
          Ir atras
        </Text>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Title>Bodegas de productos</Title>
          </Col>
        </Row>
        <WrapperTabNav
          items={[
            {
              label: `LISTADO DE PRODUCTOS EN LA BODEGA`,
              key: "1",
              children: (
                <>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    {" "}
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={() => setOpenModalAsignedProduct(true)}
                    >
                      Asignar un producto a la bodega
                    </Button>
                  </div>
                  <TableProductWarehouses />
                </>
              ),
            },
            {
              label: `LISTADO DE SALSAS EN LA BODEGA`,
              key: "2",
              children: (
                <>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                    {" "}
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={()=>setOpenModalAsignedSouce(true)}
                    >
                      Asignar una salsa a la bodega
                    </Button>
                  </div>
                  <TableSauceWarehouses />
                </>
              ),
            },
          ]}
        />
        <ModalWarehouseProducts
          openModal={openModalAsignedProduct}
          setOpenModal={setOpenModalAsignedProduct}
        />
         <ModalWarehouseSauces
         openModal={openModalAsignedSouce}
         setOpenModal={setOpenModalAsignedSouce}
        />
      </Card>
    </AdminMenuLayout>
  );
};
